import React, { useEffect, useState } from 'react';
import './SakuraBackground.css';

const SakuraBackground = () => {
  const [sakuras, setSakuras] = useState([]);

  useEffect(() => {
    const sakuraTypes = ['🌸', '🌺', '💮', '🌷'];
    
    const createSakura = () => {
      // 随机选择飘落方向：60%概率对角线，40%概率垂直
      const fallType = Math.random() < 0.6 ? 'diagonal' : 'vertical';
      
      let startPosition;
      if (fallType === 'diagonal') {
        // 对角线飘落：从整个屏幕宽度开始
        startPosition = Math.random() * 100;
      } else {
        // 垂直飘落：主要从右边区域开始
        startPosition = Math.random() * 30 + 70; // 70%-100%
      }
      
      const sakura = {
        id: Math.random(),
        left: startPosition,
        animationDuration: Math.random() * 3 + 7, // 7-10秒
        opacity: Math.random() * 0.6 + 0.4,
        size: Math.random() * 8 + 12,
        type: sakuraTypes[Math.floor(Math.random() * sakuraTypes.length)],
        fallType: fallType, // 添加飘落类型标识
        delay: Math.random() * 2, // 添加随机延迟
      };
      return sakura;
    };


    // 初始樱花 - 分批生成避免一次性出现
    const generateInitialSakuras = () => {
      for (let i = 0; i < 50; i++) {
        setTimeout(() => {
          setSakuras(prev => [...prev, createSakura()]);
        }, i * 100); // 每100ms生成一朵
      }
    };
    
    generateInitialSakuras();

    // 持续生成新樱花 - 更频繁且随机间隔
    let nextDelay = 150;
    const scheduleNext = () => {
      setTimeout(() => {
        setSakuras(prev => [...prev, createSakura()]);
        nextDelay = Math.random() * 200 + 100; // 100-300ms随机间隔
        scheduleNext();
      }, nextDelay);
    };
    
    scheduleNext();

    // 清理函数在组件卸载时会自动停止所有setTimeout
  }, []);

  useEffect(() => {
    // 清理过期的樱花
    const cleanup = setInterval(() => {
      setSakuras(prev => prev.slice(-80)); // 保持最多80个樱花
    }, 8000);

    return () => clearInterval(cleanup);
  }, []);

  return (
    <div className="sakura-container">
      {sakuras.map((sakura) => (
        <div
          key={sakura.id}
          className={`sakura-petal ${sakura.fallType === 'vertical' ? 'sakura-vertical' : 'sakura-diagonal'}`}
          style={{
            left: `${sakura.left}%`,
            animationDuration: `${sakura.animationDuration}s`,
            animationDelay: `${sakura.delay}s`,
            opacity: sakura.opacity,
            fontSize: `${sakura.size}px`,
          }}
        >
          {sakura.type}
        </div>
      ))}
    </div>
  );
};

export default SakuraBackground;


